import React from "react";

import {
  Drawer,
  makeStyles,
  Close,
  IconButton,
  AddCircleOutline,
} from "../../shared/materials/helper";

import ChallanBaseButton from "../../shared/materials/Buttons/ChallanBaseButton";
import ChallanTextInput from "../../shared/materials/Inputs/ChallanTextInput";
import ChallanPopperButton from "../../shared/materials/Buttons/ChallanPopperButton";
import AddUsersAlt from "../../../assests/icons/AddUsersAlt";
import ChallanPasswordInput from "../../shared/materials/Inputs/ChallanPasswordInput";
import Notifications from "../../../utils/notifications";
import ChallanSelectInput from "../../shared/materials/Inputs/ChallanSelectInput";
import { userRole } from "../../../data/metadata/usersMetaData";

const useStyles = makeStyles((theme) => ({
  container: {},
  drawerContainer: {
    width: "35vw",
    padding: theme.spacing(4),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  headerText: {
    fontWeight: 700,
    fontSize: 20,
  },
  subHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(3),
  },
  subheaderText: {
    fontWeight: 600,
    fontSize: 16,
  },
  subheaderSubText: {
    fontWeight: 400,
    fontSize: 12,
    margin: 0,
  },
  buttonContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

export default function CreateUser({ onUpdate }) {
  const [state, setState] = React.useState(false);
  const [user, setUser] = React.useState({
    name: "",
    username: "",
    password: "",
    grant_type: "system_admin",
    association: "",
    phone: "",
    email: "",
  });
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const classes = useStyles();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  const onSubmitClick = async (event) => {
    if (user.password !== confirmPassword) {
      Notifications.error("Password doesn't match!");
      return;
    }

    const body = Object.entries(user).reduce((prev, [key, value]) => {
      if (value) prev[key] = value;

      return prev;
    }, {});

    const status = await onUpdate({ ...body });
    if (status) {
      toggleDrawer(false)(event);
      setUser({});
      setConfirmPassword("");
    }
  };

  const onUserInfoChange = (id) => (event) => {
    setUser({ ...user, [id]: event.target.value });
  };

  const onConfPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };

  return (
    <div className={classes.container}>
      <Drawer anchor={"right"} open={state} onClose={toggleDrawer(false)}>
        <div className={classes.drawerContainer}>
          <div className={classes.header}>
            <h1 className={classes.headerText}>Add New User</h1>
            <IconButton
              onClick={toggleDrawer(false)}
              sx={{ width: 48, height: 48 }}
            >
              <Close />
            </IconButton>
          </div>
          <div className={classes.subHeader}>
            <AddUsersAlt />
            <p className={classes.subheaderText}>Invite New Users To Join</p>
            <p className={classes.subheaderSubText}>
              Invite new users as a viewer or an admin
            </p>
          </div>
          <div>
            <ChallanTextInput
              id="name-create"
              label="Name"
              placeholder={"Name of the user..."}
              onChange={onUserInfoChange("name")}
              value={user.name}
            />
            <ChallanTextInput
              id="username-create"
              label="User Name"
              placeholder={"User name of the user..."}
              onChange={onUserInfoChange("username")}
              value={user.username}
              inputProps={{
                autoComplete: "off",
              }}
            />
            <ChallanSelectInput
              id="userrole-create"
              label="User Role"
              placeholder={"Role of the user..."}
              onChange={onUserInfoChange("grant_type")}
              value={user.grant_type}
              options={userRole}
              inputProps={{
                autoComplete: "off",
              }}
            />
            <ChallanTextInput
              id="association-create"
              label="User Association"
              placeholder={"Association of the user..."}
              onChange={onUserInfoChange("association")}
              value={user.association}
              inputProps={{
                autoComplete: "off",
              }}
            />
            <ChallanTextInput
              id="phone-create"
              label="Mobile"
              placeholder={"Mobile no. of the user..."}
              onChange={onUserInfoChange("phone")}
              value={user.phone}
              inputProps={{
                autoComplete: "off",
              }}
            />
            <ChallanTextInput
              id="email-create"
              label="Email"
              placeholder={"Email of the user..."}
              onChange={onUserInfoChange("email")}
              value={user.email}
              inputProps={{
                autoComplete: "off",
              }}
            />
            <ChallanPasswordInput
              id="password-create"
              label="Password"
              placeholder={"Password of the user..."}
              onChange={onUserInfoChange("password")}
              value={user.password}
              inputProps={{
                autoComplete: "new-password",
                form: {
                  autoComplete: "off",
                },
              }}
            />
            <ChallanPasswordInput
              id="conf-password-create"
              label="Confirm Password"
              placeholder={"Confirm Password of the user..."}
              onChange={onConfPasswordChange}
              value={confirmPassword}
              inputProps={{
                autoComplete: "new-password-conf",
                form: {
                  autoComplete: "off",
                },
              }}
            />
            {/* <ChallanTextInput
              id="email"
              label="Email Address"
              placeholder={"Email address of the user..."}
              // onChange={onChangeUserName}
              value={""}
            /> */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              paddingBottom: 16,
              paddingTop: 16,
            }}
          >
            <ChallanBaseButton
              onClick={toggleDrawer(false)}
              text={"Cancel"}
              type={"cancel"}
              width={"48%"}
            />
            <ChallanBaseButton
              onClick={onSubmitClick}
              text={"Create User"}
              type={"ok"}
              width={"48%"}
            />
          </div>
        </div>
      </Drawer>
      <ChallanPopperButton
        variant="contained"
        borderColor={"rgba(226, 19, 110, 0)"}
        bg={"rgba(226, 19, 110, 1)"}
        color={"#fff"}
        width={150}
        onClick={toggleDrawer(true)}
      >
        <div className={classes.buttonContent}>
          <AddCircleOutline sx={{ mr: 1 }} />
          <span>Add new</span>
        </div>
      </ChallanPopperButton>
    </div>
  );
}
